<template>
    <Link class="block w-full px-4 py-2 text-left text-sm leading-5 text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 font-medium ubuntu">
        <slot />
    </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: ['page']
}
</script>
